import NotFound from '@app/not-found';
import { routeTree } from '@src/routeTree.gen';
import { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

export type MyRouterContext = {
  queryClient: QueryClient;
};

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <NotFound />,
  notFoundMode: 'root',
  defaultPreload: 'intent',
  context: {
    queryClient: undefined!,
  },
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
